export default __webpack_public_path__ + "static/media/40317.09ec3966.jpg";